import {
  Component,
  AfterContentChecked,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { FieldArrayType, FormGlobalService } from "@kre-form/core";
import {
  KreFormCommonService,
  KreFormTemplateOptions,
  KreFormFieldConfig,
} from "@kre-form/core";

import * as _ from "lodash";
import { KreFormAntService } from "../../tools/service";

@Component({
  selector: "kreform-repeat",
  templateUrl: "./index.html",
  host: {
    "[class]": 'field.className || ""',
    cdkDrag: "",
  },
})
export class KreFormFieldRepeat
  extends FieldArrayType
  implements OnInit, OnDestroy, AfterContentChecked
{
  service: any;
  titles: KreFormTemplateOptions[] = [];
  showXScroll = true;
  screenTableWidth = window.screen.width - 162;
  tableWidth = 0;
  length = 0;

  constructor(
    dyService: KreFormAntService,
    private globalService: FormGlobalService
  ) {
    super();
    this.service = dyService;
  }
  ngAfterContentChecked() {
    if (_.isEmpty(this.field.fieldGroup)) {
      this.showXScroll = false;
    } else {
      this.showXScroll = true;
    }
  }
  ngOnInit() {
    if (this.formControl) {
      this.formControl.valueChanges.subscribe((res) => {
        if (res.length !== this.length) {
          this.length = res.length;
          if (this.to!.enableInterface) {
            this.globalService.notifyDataChanged("repeatLengthChange", {
              rdm: Math.random(),
              config: this.field,
            });
          }
        }
      });
    }
    if (this.field!.fieldGroup) {
      this.length = this.field!.fieldGroup!.length;
    }

    if (!!(this.field as any)["repeatRole"]) {
      Object.keys((this.field as any)["repeatRole"]).forEach(
        (repeatKeyIndex: string) => {
          let index: number = Number(
            repeatKeyIndex.substr(repeatKeyIndex.lastIndexOf("$") + 1)
          );

          if (!!this.field.fieldGroup) {
            this.field.fieldGroup.forEach((field: any, ind: number) => {
              if (index === ind) {
                field.fieldGroup.forEach((repeatField: any) => {
                  if (
                    !!(this.field as any)["repeatRole"][repeatKeyIndex][
                      repeatField.key
                    ]
                  ) {
                    if (
                      repeatField.templateOptions === undefined ||
                      repeatField.templateOptions === null
                    ) {
                      repeatField.templateOptions = {};
                    }
                    if (
                      repeatField.editProperty === undefined ||
                      repeatField.editProperty === null
                    ) {
                      repeatField.editProperty = {};
                    }
                    repeatField.templateOptions = Object.assign(
                      repeatField.templateOptions,
                      (this.field as any)["repeatRole"][repeatKeyIndex][
                        repeatField.key
                      ].templateOptions
                    );
                    if (
                      (this.field as any)["repeatRole"][repeatKeyIndex][
                        repeatField.key
                      ]["editor"] === false ||
                      (this.field as any)["repeatRole"][repeatKeyIndex][
                        repeatField.key
                      ]["editor"] === true
                    ) {
                      repeatField.editor = (this.field as any)["repeatRole"][
                        repeatKeyIndex
                      ][repeatField.key]["editor"];
                    }

                    if (
                      (this.field as any)["repeatRole"][repeatKeyIndex][
                        repeatField.key
                      ]["show"] === false ||
                      (this.field as any)["repeatRole"][repeatKeyIndex][
                        repeatField.key
                      ]["show"] === true
                    ) {
                      repeatField.show = (this.field as any)["repeatRole"][
                        repeatKeyIndex
                      ][repeatField.key]["show"];
                    }

                    repeatField.editProperty = Object.assign(
                      repeatField.editProperty,
                      (this.field as any)["repeatRole"][repeatKeyIndex][
                        repeatField.key
                      ].editProperty
                    );
                  }
                });
              }
            });
          }
        }
      );
    }

    if (!!this.field["show"]) {
      this.field.hide = !this.field["show"];
    }
    this.changeWidth();
    window.addEventListener("resize", this.chartresize, true);
  }
  ngOnDestroy() {
    window.removeEventListener("resize", this.chartresize, true);
  }
  fieldOperational(sign: string) {
    this.service.fieldOperational(sign, this.field);
  }

  groupOperational(type: string) {
    this.service.groupOperational(type, this.field);
  }

  delete(i: any) {
    if (this.field.fieldGroup && this.field.fieldGroup.length > 1) {
      this.remove(i);
    } else {
    }
  }

  chartresize = () => {
    this.changeWidth();
  };
  changeWidth() {
    let width = 300;
    if (
      this.field != undefined &&
      this.field != null &&
      this.field.fieldArray != undefined &&
      this.field.fieldArray != null &&
      this.field.fieldArray.fieldGroup != undefined &&
      this.field.fieldArray.fieldGroup != null
      // && !_.isEmpty(this.field.fieldGroup)
    ) {
      let length = this.field!.fieldArray!.fieldGroup!.filter((title) =>
        this.checkFieldShow(title)
      ).length;
      width = length * 245 + 120;
    }
    this.tableWidth = width;

    if (_.isEmpty(this.field.fieldGroup)) {
      this.showXScroll = false;
    } else {
      // this.showXScroll = true;
    }
  }
  addIndex() {
    this.showXScroll = true;
    (this.field.fieldGroup as any[]).forEach((el: any, index: number) => {
      el.fieldGroup.forEach((ele: any) => {
        ele.templateOptions.index = index;
        if (
          this.field &&
          this.field.templateOptions &&
          (!!this.field.templateOptions.index ||
            this.field.templateOptions.index === 0)
        ) {
          ele.templateOptions.pIndex = this.field.templateOptions.index;
        }
      });
    });
  }
  isRemoved(f: KreFormFieldConfig): boolean {
    let result = true;
    if (this.editor === false) {
      result = false;
    }

    if (
      f!
        .fieldGroup!.filter(
          (el) => el.type !== "line" && el.type !== "htmlcontent"
        )!
        .every((el: any) => !!el!.editProperty && !!el!.editProperty!.delete)
    ) {
      result = false;
    }
    return result;
  }
  removed(i: number, isRemove: boolean) {
    if (!isRemove) {
      return;
    }
    this.remove(i);
    if (!!this.operationProperty && !!this.operationProperty.deleteEvent) {
      this.globalService.notifyDataChanged("FieldWrapperClick", {
        rdm: Math.random(),
        config: this.field,
        type: "repeat",
      });
    }

    this.globalService.notifyDataChanged("repeatDelete", {
      rdm: Math.random(),
      index: i,
      config: this.field,
    });
    this.addIndex();

    if (_.isEmpty(this.field.fieldGroup)) {
      this.showXScroll = false;
    }
  }
  showErrors() {
    let that = this;
    return that.showError;
  }
  newRowId(i: number): string {
    return `${this.field.id}_${i}`;
  }
  newRepeatClass(): string {
    return `${this.field.id}_repeat`;
  }

  checkFieldShow(field: KreFormFieldConfig): boolean {
    let result: boolean = true;
    if (
      (!field ||
        !field.type ||
        field.type === "line" ||
        field.type === "htmlcontent") &&
      field.show === undefined
    ) {
      field.show = true;
      field.hide = false;
    }
    if (this.formStatus === 0) {
      if (field && field.hasOwnProperty("show")) {
        result = (field.show || false) as boolean;
      }
    }
    if (field.show === false) {
      field.hide = true;
    }

    return result;
  }
}
